function padTime(value) {
	return String(value).padStart(2, '0')
}

export function formatSessionNoteDate(value) {
	if (!value) return '—'
	const date = new Date(value)
	if (Number.isNaN(date.getTime())) return '—'
	return date.toLocaleDateString('en-US', {
		month: 'short',
		day: 'numeric',
		year: 'numeric',
	})
}

export function formatSessionNoteDuration(durationMs) {
	const totalSeconds = Math.max(0, Math.round(Number(durationMs || 0) / 1000))
	const hours = Math.floor(totalSeconds / 3600)
	const minutes = Math.floor((totalSeconds % 3600) / 60)
	const seconds = totalSeconds % 60

	if (hours > 0) return `${hours}h ${padTime(minutes)}m`
	if (minutes > 0) return `${minutes}m ${padTime(seconds)}s`
	return `${seconds}s`
}

export function formatActionItemCount(count) {
	const value = Number(count) || 0
	return value === 1 ? '1 action' : `${value} actions`
}

export function getStudentFirstName(studentName = '') {
	return String(studentName || 'Student').trim().split(/\s+/)[0] || 'Student'
}
